import { useState, useCallback } from "react";
import {
  ErrorMessage,
  InfoMessage,
  SuccessMessage,
} from "../../../src/utils/toastify";
import useFileReader from "./useFileReader";
function useFileUpload() {
  const { readProgress, progress, resetProgress } = useFileReader();
  const [initProgress, setInitProgress] = useState(false);
  const [fileInformation, setFileInformation] = useState(null);

  const upload = useCallback(
    async (file) => {
      InfoMessage("Cargando archivo, por favor espere...");
      try {
        setInitProgress(true);
        await readProgress(file);
        SuccessMessage("Archivo cargado exitosamente");
        setInitProgress(false);
        setFileInformation({
          name: file.name,
          size: file.size,
          type: file.type,
        });
      } catch (error) {
        setInitProgress(false);
        ErrorMessage("Error al cargar el archivo");
      }
    },
    [readProgress, resetProgress],
  );

  const reset = useCallback(() => {
    setInitProgress(false);
    resetProgress();
    setFileInformation(null);
  }, []);

  return {
    upload,
    progress,
    initProgress,
    resetProgress,
    fileInformation,
    reset,
  };
}

export default useFileUpload;
